module.exports = __webpack_public_path__ + "media/700_SERF_2022_PhishingAttacks.1c769471.mp4";